<template>
	<div class="chartToggles">
		<div class="chartToggle" :class="active.includes(toggle.id) ? 'chartToggle--active' : ''" v-for="toggle in toggles" :key="toggle.id" @click="change(toggle.id)">
			{{toggle.wording}}
		</div>
		<div class="chartToggle --filler" v-for="i in 5" :key="'charttoggle-filler-' + i">
		</div>
	</div>
</template>
<script>
	export default {
		name: 'ChartToggles',
		props: {
			toggles: {
				type: Array,
				required: true,
			},
			active: {
				type: Array,
				default: () => [],
			}
		},
		methods: {
			change: function(id) {
				this.$emit('change', id)
			}
		},
	}
</script>
<style lang="scss">
	@import 'global/css/contexte.apps.colors';
	.chartToggles {
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		margin: 0 -.5em;
		width: calc(100% + 1em);
	} 
	.chartToggle {
		border-top: 1px solid $light-grey;
		padding-top: .3em;
		font-size: .75em;
		opacity: .5;
		flex: 1 1 100px;
		margin: 0 .5em .6em;
		cursor: pointer;
		&--active {
			border-color: $dark-grey;
			opacity: 1;
		}
	}
	@media screen and (min-width: 1200px)  {
		.chartToggle {
			font-size: .9em;
		}
	}
</style>